export default "###### My Payment Progress\n\nYou can view the progress of your payments here.\n";